// 서비스 페이지 정의.
//
// 검색은 한 페이지가 한 검색어를 먹는다. 홈 하나로 "업무 자동화 프로그램 제작"
// 같은 머리 키워드를 먹으려 하면 큰 업체들과 정면으로 붙어 못 이긴다.
// 그래서 기업이 실제로 치는 말마다 페이지를 따로 둔다.
//
// 검색어는 marketing/keywords/b2b.json 에서 뽑았다. 네이버·구글 자동완성을
// 긁은 것이라 추측이 아니다. 다시 뽑으려면 marketing/keywords/harvest.py.
//
// 검색용 제목은 네이버 검색광고 키워드도구의 실제 월간 검색수로 골랐다
// (marketing/keywords/volume.json). 처음에는 자동완성 순위를 검색량으로
// 착각해 "챗봇 구축 비용", "LLM 도입 비용" 같은 말을 노렸는데, 재 보니
// 전부 월 10회 미만이었다. 자동완성은 그 말이 있다는 것만 알려준다.
//
// 금액은 위시켓 실거래 공개치(누적 9,511억원 규모)를 기준으로 적는다.
// 우리 수주가를 적는 게 아니라 "이 종류는 시장에서 이 정도"를 밝히는 것이다.
// 기업 담당자는 내부 보고용 숫자를 찾는 것이라, 범위만 있어도 쓸모가 있다.

export const SERVICES = [
    {
        slug: "ai-chatbot",
        nav: "AI 챗봇·응대 자동화",
        h1: "AI 챗봇 구축",
        seoTitle: "AI 챗봇 만들기·구축 — 인공지능 챗봇 개발, 상담 자동화",
        seoDesc:
            "문의 응대를 대신하는 AI 챗봇과 AI 에이전트를 만듭니다. 시나리오형부터 사내 문서를 "
            + "읽고 답하는 방식까지. 비용 범위와 기간, 실제 구축 사례를 공개합니다.",
        lede:
            "들어오는 문의의 대부분은 같은 질문입니다. 사람이 반복해서 답하던 것을 "
            + "챗봇이 받고, 판단이 필요한 것만 사람에게 넘깁니다.",
        price: { range: "1,500만 ~ 5,000만원", period: "2 ~ 4개월" },
        priceNote:
            "규칙만 태우는 시나리오형이면 300만~1,500만원·2~4주로 떨어집니다. "
            + "사내 문서를 읽고 답해야 하면 올라갑니다.",
        sections: [
            {
                h: "어디까지 자동으로 받나",
                body: [
                    "문의 응대는 세 층으로 나뉩니다. 답이 정해진 것, 자료를 찾아야 답할 수 있는 것, "
                    + "사람이 판단해야 하는 것입니다.",
                    "첫 층은 시나리오로 처리합니다. 둘째 층은 사내 문서·상품 정보·과거 상담 기록을 "
                    + "검색해 그 근거로 답하게 만듭니다. 셋째 층은 사람에게 넘기되, 그때까지의 "
                    + "대화를 정리해서 같이 넘깁니다.",
                    "셋째 층을 억지로 자동화하면 틀린 답이 나가고, 그 한 번이 쌓아둔 신뢰를 "
                    + "다 깎습니다. 경계를 어디에 둘지 먼저 정하고 시작합니다.",
                ],
            },
            {
                h: "어디에 붙이나",
                body: [
                    "홈페이지 위젯, 카카오톡 채널, 인스타그램 DM·댓글, 사내 메신저에 붙입니다. "
                    + "채널마다 쓸 수 있는 기능이 달라서, 한 번 만든 응대 흐름을 채널별로 "
                    + "맞춰 내보내는 구조로 짭니다.",
                    "응대 내용을 바꿀 때마다 개발자를 부르지 않아도 되도록, 흐름을 화면에서 "
                    + "고치는 편집기를 같이 만드는 경우가 많습니다.",
                ],
            },
            {
                h: "챗봇 빌더로 충분한 경우와 개발이 필요한 경우",
                body: [
                    "자주 묻는 질문 수십 개에 정해진 답을 하는 정도라면 카카오 챗봇 관리자나 "
                    + "시중 챗봇 빌더로 직접 만드시는 게 쌉니다. 그런 문의엔 그렇게 말씀드립니다.",
                    "개발이 필요해지는 건 셋 중 하나입니다. 사내 문서·상품 정보를 읽고 답해야 할 때, "
                    + "주문·예약·회원 정보처럼 우리 시스템을 조회해야 할 때, 여러 채널의 대화를 "
                    + "한 곳에서 관리해야 할 때입니다.",
                ],
            },
            {
                h: "인공지능 챗봇은 이렇게 답합니다",
                body: [
                    "질문이 들어오면 먼저 사내 자료에서 관련 부분을 찾고, 그 내용만 근거로 답을 "
                    + "만들게 합니다. 모델이 아는 척 지어내는 걸 막는 방법입니다.",
                    "근거를 못 찾으면 답하지 않고 사람에게 넘깁니다. 어떤 자료를 보고 답했는지 "
                    + "로그에 남겨서, 틀린 답이 나오면 어느 문서를 고쳐야 하는지 바로 보입니다.",
                    "쓰는 만큼 AI 이용료가 나갑니다. 문의량을 받아 월 비용을 미리 계산해 드리고, "
                    + "정해진 답이 있는 질문은 AI 를 거치지 않게 해서 비용을 줄입니다.",
                ],
            },
            {
                h: "진행 순서",
                body: [
                    "1. 최근 문의 내역을 받아 유형별로 나눕니다. 몇 퍼센트를 자동으로 받을 수 있는지가 여기서 나옵니다.",
                    "2. 답의 근거가 될 자료를 모으고 정리합니다. 대부분 이 단계가 제일 깁니다.",
                    "3. 실제 지난 문의로 돌려 보고, 틀린 답과 못 받은 질문을 고칩니다.",
                    "4. 한 채널에 먼저 붙여 운영해 보고 나머지 채널로 넓힙니다.",
                ],
            },
        ],
        related: [
            { to: "/blog/ai-chatbot-build-guide", label: "AI 챗봇 만들기 — 빌더로 끝나는 경우와 개발이 필요한 경우" },
        ],
        deliverables: [
            "응대 흐름 편집기 (개발자 없이 문구·분기 수정)",
            "상담원 전환 — 대화 요약과 함께 사람에게 인계",
            "응대 로그와 통계 (무엇을 못 답했는지가 제일 중요합니다)",
            "채널 연동 (홈페이지 / 카카오 / 인스타 / 사내 메신저)",
        ],
        cases: ["sendit-instagram-dm", "deungi-cloud"],
        faq: [
            {
                q: "학습시킬 데이터가 정리돼 있지 않은데요",
                a: "대부분 그렇습니다. 흩어진 문서와 과거 상담 기록을 모아 정리하는 것부터가 "
                    + "작업에 들어갑니다. 이 공수가 전체 비용에서 꽤 큰 몫을 차지합니다.",
            },
            {
                q: "엉뚱한 답을 하면요",
                a: "모르면 모른다고 하고 사람에게 넘기도록 만듭니다. 답변률을 억지로 올리는 것보다 "
                    + "틀린 답을 안 하는 쪽이 중요합니다. 못 답한 질문은 전부 기록돼서 다음 보완 거리가 됩니다.",
            },
            {
                q: "ChatGPT 를 그냥 붙이면 안 되나요",
                a: "붙일 수는 있지만 우리 회사 정보를 모르니 그럴듯한 틀린 답을 합니다. 사내 자료를 "
                    + "찾아 근거로 주는 부분과, 모를 때 멈추는 부분이 실제 개발 범위입니다.",
            },
            {
                q: "카카오톡 채널에도 붙일 수 있나요",
                a: "됩니다. 홈페이지·카카오톡·인스타그램 DM 에 같은 응대 흐름을 내보낼 수 있고, "
                    + "상담원 연결도 채널별로 맞춥니다.",
            },
        ],
    },

    {
        slug: "ai-ocr",
        nav: "AI OCR·문서 자동화",
        h1: "OCR 프로그램 제작",
        seoTitle: "OCR 프로그램 제작 — PDF OCR · AI OCR 맞춤 개발",
        seoDesc:
            "서류를 읽어 시스템에 자동 입력하는 OCR 프로그램을 만듭니다. PDF·스캔 문서, "
            + "선적서류·세무서류·명함까지. 실제 구축 사례와 비용 범위를 공개합니다.",
        lede:
            "받은 서류를 사람이 보고 다시 시스템에 치는 일. 이게 가장 흔하고, "
            + "가장 확실하게 줄어드는 업무입니다.",
        price: { range: "1,000만 ~ 3,500만원", period: "2 ~ 5개월" },
        priceNote:
            "서식이 정해진 문서 한 종류면 아래쪽, 거래처마다 양식이 다르고 뒤에 "
            + "기간계 연동까지 붙으면 위쪽입니다.",
        sections: [
            {
                h: "글자만 읽는 것과 뜻까지 읽는 것은 다릅니다",
                body: [
                    "예전 OCR 은 글자를 뽑아줄 뿐이라, 어느 글자가 품목이고 어느 숫자가 "
                    + "수량인지는 사람이 다시 봐야 했습니다. 서식이 조금만 달라져도 무너졌고요.",
                    "지금은 문서를 통째로 읽혀서 필요한 항목을 뽑아냅니다. 거래처마다 양식이 "
                    + "달라도 같은 항목을 찾아냅니다. 양식별로 규칙을 짜지 않아도 됩니다.",
                    "다만 완벽하지 않습니다. 그래서 확신이 낮은 항목은 표시해서 사람이 "
                    + "확인하게 만듭니다. 전부 자동으로 넘기는 것보다 이 편이 안전합니다.",
                ],
            },
            {
                h: "읽은 다음이 진짜 일입니다",
                body: [
                    "뽑아낸 값을 어디로 보내느냐가 실제 공수입니다. ERP 에 입력하든, "
                    + "엑셀로 떨구든, 사내 시스템 API 를 치든 거기서 일이 갈립니다.",
                    "기존 시스템에 API 가 없는 경우도 많습니다. 그때는 화면을 직접 조작하는 "
                    + "방식으로 붙입니다. 느리지만 기존 시스템을 건드리지 않아도 됩니다.",
                ],
            },
        ],
        deliverables: [
            "문서 업로드 → 항목 추출 → 검수 화면",
            "확신 낮은 항목 표시 (사람이 볼 곳만 보게)",
            "기간계 연동 (ERP · 사내 시스템 · 구글 시트 · 엑셀)",
            "처리 이력 — 어떤 서류가 언제 무엇으로 들어갔는지",
        ],
        cases: ["shipping-docs-erp-automation", "tour-quote-automation", "led-tablet-quote", "tax-docs-auto-issue"],
        faq: [
            {
                q: "인식률이 몇 퍼센트 나오나요",
                a: "문서 종류와 상태에 따라 달라서 미리 숫자를 드리지 않습니다. 대신 실제 "
                    + "서류 몇 장을 받아 돌려보고 결과를 먼저 보여드립니다. 그 다음에 할지 말지 정하시면 됩니다.",
            },
            {
                q: "손글씨도 되나요",
                a: "인쇄물보다 떨어집니다. 손글씨가 섞인 서류는 그 칸만 사람이 확인하도록 "
                    + "따로 빼는 쪽으로 설계합니다.",
            },
        ],
    },

    {
        slug: "llm",
        nav: "AI 자동화",
        h1: "AI 자동화 · AI 프로그램 제작",
        seoTitle: "AI 자동화 — AI 프로그램 제작·업무 적용 사례",
        seoDesc:
            "AI 를 실제 업무에 붙인 사례와 비용을 공개합니다. 어디에 쓰면 되고 어디에 쓰면 "
            + "안 되는지, 무엇부터 해야 하는지 정리했습니다.",
        lede:
            "도입 자체가 목적이면 돈만 씁니다. 지금 사람이 하는 일 중 어느 것을 "
            + "줄일지가 먼저고, 거기에 맞는 방법을 고르는 게 그 다음입니다.",
        price: { range: "1,500만 ~ 4,000만원", period: "3 ~ 6주 (적용 검증)" },
        priceNote:
            "먼저 한 업무에 붙여 되는지 확인하는 단계의 금액입니다. 그 뒤 "
            + "전사 적용으로 넘어가면 규모가 달라집니다.",
        sections: [
            {
                h: "되는 일과 안 되는 일",
                body: [
                    "잘 되는 쪽은 읽고 정리하는 일입니다. 서류에서 항목 뽑기, 긴 문서 요약, "
                    + "문의 분류, 초안 쓰기, 자유롭게 쓰인 글을 정해진 칸에 넣기.",
                    "안 되는 쪽은 틀리면 안 되는 계산과 매번 같아야 하는 판단입니다. 금액 계산을 "
                    + "맡기면 안 됩니다. 그런 건 코드로 짜고, 생성형 AI 는 그 앞뒤에서 "
                    + "읽고 쓰는 일만 맡깁니다.",
                    "이 경계를 안 그으면 그럴듯한데 틀린 결과가 나오고, 틀린 걸 찾느라 "
                    + "원래 일보다 시간이 더 듭니다.",
                ],
            },
            {
                h: "작게 먼저 해보시는 걸 권합니다",
                body: [
                    "전사 도입부터 잡으면 어디서 막힐지 모른 채로 예산이 묶입니다. "
                    + "업무 하나를 골라 3~6주로 붙여 보고, 실제로 시간이 줄었는지 숫자로 확인한 "
                    + "다음에 넓히는 쪽이 안전합니다.",
                    "이 단계에서 확인할 것은 정확도만이 아닙니다. 담당자가 실제로 쓰는지, "
                    + "결과를 믿는지, 검수에 드는 시간이 얼마인지가 더 중요합니다.",
                ],
            },
        ],
        deliverables: [
            "업무 한 건에 붙인 동작하는 결과물",
            "전/후 처리 시간 비교 — 실제로 줄었는지",
            "모델 사용 비용 추정 (월 단위)",
            "넓힐 때의 범위와 순서",
        ],
        cases: ["sendit-instagram-dm", "shipping-docs-erp-automation", "tour-quote-automation"],
        faq: [
            {
                q: "사내 자료를 외부 모델에 보내도 되나요",
                a: "민감한 자료면 보내지 않는 구조로 짭니다. 자료를 그대로 넘기지 않고 필요한 "
                    + "부분만 가리고 보내거나, 내부에 모델을 두는 방식이 있습니다. 어느 쪽이든 비용과 "
                    + "성능이 달라지므로 처음에 정합니다.",
            },
            {
                q: "월 비용이 얼마나 나오나요",
                a: "쓰는 만큼 나갑니다. 적용 검증 단계에서 실제 사용량을 재서 월 얼마인지 "
                    + "숫자로 드립니다. 대개 생각보다 적지만, 긴 문서를 통째로 넣는 설계면 크게 뜁니다.",
            },
        ],
    },

    {
        slug: "platform",
        nav: "관리 시스템·플랫폼",
        h1: "고객관리 · 회원관리 · 재고관리 프로그램 제작",
        seoTitle: "고객관리 프로그램 제작 — 회원관리·재고관리 시스템 개발",
        seoDesc:
            "업무에 맞는 관리 시스템을 만듭니다. 고객관리·회원관리·재고관리부터 회원·결제가 "
            + "들어가는 플랫폼까지. 비용 범위와 실제 구축 사례를 공개합니다.",
        lede:
            "쓰는 사람이 여럿이고, 돈이 오가고, 관리자가 들여다봐야 하는 서비스입니다. "
            + "프로그램 하나 만드는 것과는 규모가 다릅니다.",
        price: { range: "3,000만 ~ 7,000만원", period: "4 ~ 9개월" },
        priceNote:
            "위시켓 실거래 기준 매칭 플랫폼 구간입니다. 스타트업 MVP 로 "
            + "범위를 좁히면 1,500만~3,000만원·2~3개월로 끊을 수 있습니다.",
        sections: [
            {
                h: "처음부터 다 만들지 않습니다",
                body: [
                    "기획서에 적힌 기능을 전부 만들면 반년이 가고, 그동안 시장이 어떤지 모른 채로 "
                    + "돈이 나갑니다. 돈 받는 흐름 하나를 먼저 끝까지 뚫는 쪽이 낫습니다.",
                    "가입해서, 쓰고, 결제하고, 관리자가 확인하는 한 줄. 이게 돌아가면 "
                    + "그 위에 얹는 건 그 다음 문제입니다.",
                ],
            },
            {
                h: "관리자 화면을 빼먹지 마세요",
                body: [
                    "외주로 만든 서비스가 운영에서 막히는 이유는 대개 관리자 화면이 부실해서입니다. "
                    + "고객이 문의할 때마다 개발자한테 데이터베이스를 봐달라고 해야 하면 그 서비스는 "
                    + "운영이 안 됩니다.",
                    "회원 조회, 결제 내역, 환불 처리, 설정 변경을 직접 하실 수 있게 만듭니다. "
                    + "눈에 안 보여서 견적에서 자주 빠지는데, 빼면 나중에 더 듭니다.",
                ],
            },
        ],
        deliverables: [
            "회원·권한·결제 (정기 결제 포함)",
            "운영자용 관리 화면",
            "서버 구성과 배포 — 넘겨드린 뒤에도 직접 올리실 수 있게",
            "API 문서 (외부 연동이 필요한 경우)",
        ],
        cases: ["sendit-instagram-dm", "dig-influencer-risk", "deungi-cloud", "academy-attendance-system"],
        faq: [
            {
                q: "만든 다음 유지보수는요",
                a: "소스와 서버를 그대로 넘겨드립니다. 직접 하셔도 되고, 월 단위로 맡기셔도 됩니다. "
                    + "묶어 파는 구조로 만들지 않습니다.",
            },
            {
                q: "기획이 아직 정리가 안 됐습니다",
                a: "그 상태로 시작하면 중간에 범위가 계속 바뀌어서 서로 손해입니다. 먼저 화면 단위로 "
                    + "범위를 같이 정리하는 것부터 하고, 그 결과로 견적을 냅니다.",
            },
        ],
    },

    {
        slug: "rpa",
        nav: "업무 자동화",
        h1: "업무 자동화 프로그램 제작",
        seoTitle: "업무 자동화 프로그램 제작 — 사무자동화·RPA 맞춤 개발",
        seoDesc:
            "사람이 반복하던 업무를 프로그램이 대신하게 만듭니다. 서류 발급, 데이터 수집, "
            + "정산, 배차까지 실제 구축 사례와 비용 범위를 공개합니다.",
        lede:
            "매일 같은 순서로 하는 일이면 대부분 넘길 수 있습니다. "
            + "기존 시스템을 갈아엎지 않고 그 위에 얹습니다.",
        price: { range: "500만 ~ 3,000만원", period: "1 ~ 4개월" },
        priceNote:
            "업무 하나를 자동화하는 건 아래쪽, 여러 업무를 묶어 사내 시스템으로 "
            + "만드는 건 위쪽입니다.",
        sections: [
            {
                h: "기존 시스템을 안 건드립니다",
                body: [
                    "쓰고 계신 ERP 나 그룹웨어를 바꾸자는 이야기가 아닙니다. 사람이 그 화면에서 "
                    + "하던 동작을 프로그램이 대신하게 만드는 쪽입니다. 기존 시스템은 그대로 둡니다.",
                    "API 가 열려 있으면 그쪽을 씁니다. 없으면 화면을 조작합니다. 후자는 화면이 "
                    + "바뀌면 같이 손봐야 하지만, 대부분의 국내 업무 시스템이 API 를 안 열어둬서 "
                    + "실제로는 이쪽이 더 많습니다.",
                ],
            },
            {
                h: "자동화할 가치가 있는지부터",
                body: [
                    "하루 5분 걸리는 일을 자동화하려고 2주를 쓰면 손해입니다. 들어가는 공수와 "
                    + "줄어드는 시간을 먼저 계산해서, 안 맞으면 하지 마시라고 말씀드립니다.",
                    "횟수가 잦고, 규칙이 분명하고, 틀리면 바로 티가 나는 일이 좋습니다. "
                    + "반대로 매번 판단이 달라지는 일은 자동화해도 검수에 시간이 더 듭니다.",
                ],
            },
            {
                h: "이런 업무를 넘기십니다",
                body: [
                    "여러 사이트에 로그인해 서류를 내려받고 이름 붙여 정리하는 일. 세무서류 4종을 "
                    + "간편인증 한 번으로 발급받아 업무 보드에 자동으로 붙이는 프로그램을 만들었습니다.",
                    "거래처 엑셀을 우리 양식으로 옮기고, 주소를 정리하고, 배송 순서를 짜는 일. "
                    + "주문 파일을 올리면 주소 정제부터 경로 계산까지 한 번에 끝나게 했습니다.",
                    "같은 내용을 이름만 바꿔 수백 곳에 보내거나, 여러 채널에 같은 글을 올리는 일. "
                    + "발송량과 속도를 조절해 차단되지 않게 하는 쪽이 실제 공수입니다.",
                ],
            },
            {
                h: "UiPath 같은 RPA 툴과 무엇이 다른가",
                body: [
                    "기성 RPA 툴은 자동화할 업무가 수십 개이고, 그걸 맡을 담당자가 사내에 있을 때 "
                    + "맞습니다. 툴을 깔아 두고 직접 흐름을 늘려 가는 방식이라 길게 보면 쌉니다.",
                    "업무 두세 개만 없어지면 되는 회사라면 이야기가 다릅니다. 매년 라이선스에, 툴을 "
                    + "배울 사람에, 흐름을 짜 줄 외주까지 붙습니다. 그 업무만 하는 프로그램을 만드는 "
                    + "편이 단순하고, 실행하는 사람은 버튼 하나만 누르면 됩니다.",
                    "국내 사이트의 간편인증·공동인증서 단계나, 결과를 사내 ERP·메신저로 바로 넘기는 "
                    + "부분은 맞춤 개발 쪽이 다루기 쉽습니다.",
                ],
            },
            {
                h: "진행 순서",
                body: [
                    "1. 지금 하시는 순서를 화면 녹화나 엑셀 샘플로 받습니다. 이것만 있으면 영업일 "
                    + "1~2일 안에 되는지 안 되는지와 금액을 먼저 말씀드립니다.",
                    "2. 예외 상황을 같이 정리합니다. \"보통은 이런데 이럴 땐 이렇게\" 가 몇 개냐가 "
                    + "실제 공수라, 여기서 범위가 확정됩니다.",
                    "3. 실제 데이터로 돌려 보면서 고칩니다. 첫 버전은 보통 2~3주 안에 손에 쥐어 드립니다.",
                    "4. 넘겨드린 뒤에도 대상 화면이 바뀌면 손봐야 해서, 유지보수 범위를 계약 때 정해 둡니다.",
                ],
            },
        ],
        related: [
            { to: "/blog/office-automation-program-guide", label: "업무자동화 프로그램, RPA 툴을 살까 따로 만들까" },
            { to: "/blog/when-to-automate", label: "이 업무, 자동화할 가치가 있을까 — 판단 기준 4가지" },
            { to: "/blog/excel-document-automation", label: "세무서류 4종을 매달 손으로 발급받고 있다면" },
        ],
        deliverables: [
            "실행 파일 또는 서버에서 도는 작업",
            "실행 이력과 실패 알림 (조용히 멈추는 게 제일 위험합니다)",
            "실패 시 재시도와 건너뛰기 규칙",
            "담당자용 간단한 조작 화면",
        ],
        cases: ["tax-docs-auto-issue", "delivery-route-optimizer", "bulk-email-sender", "python-automation-suite", "csharp-automation-suite"],
        faq: [
            {
                q: "자동화가 중간에 멈추면 어떻게 아나요",
                a: "멈춘 걸 모르는 게 제일 큰 문제라, 실패하면 메일이나 메신저로 알리도록 "
                    + "기본으로 넣습니다. 몇 건을 처리했고 몇 건이 실패했는지도 남깁니다.",
            },
            {
                q: "상대 사이트가 막아두면요",
                a: "자동 접근을 막아둔 곳은 뚫지 않습니다. 약관 위반이고 계정이 정지됩니다. "
                    + "그런 경우는 받지 않거나, 공식 API 가 있으면 그쪽으로 돌립니다.",
            },
            {
                q: "업무자동화 프로그램은 어디서 돌아가나요",
                a: "담당자 PC 에서 실행하는 프로그램으로 드리거나, 서버에 올려 정해진 시각에 "
                    + "스스로 돌게 합니다. 사람이 버튼을 눌러야 하는 일이면 전자, 밤사이 돌아야 "
                    + "하는 일이면 후자가 맞습니다.",
            },
            {
                q: "이미 UiPath 를 쓰고 있는데 같이 쓸 수 있나요",
                a: "됩니다. 툴로 다루기 까다로운 단계만 프로그램으로 만들어 툴에서 부르게 하는 "
                    + "경우도 있습니다. 쓰시던 걸 바꾸자고 하지 않습니다.",
            },
            {
                q: "소스 코드도 받을 수 있나요",
                a: "드립니다. 나중에 다른 곳에 맡기시더라도 막히지 않아야 합니다.",
            },
        ],
    },

    {
        slug: "integration",
        nav: "ERP 연동·개발",
        h1: "ERP 프로그램 연동 · 개발",
        seoTitle: "ERP 프로그램 연동 — 더존·이카운트 ERP 시스템 개발",
        seoDesc:
            "따로 노는 시스템 사이에 데이터가 자동으로 흐르게 만듭니다. 더존·이카운트 등 "
            + "ERP 시스템, 그룹웨어, 쇼핑몰, 외부 API 연동. 실제 구축 사례를 공개합니다.",
        lede:
            "시스템은 여럿인데 사이를 사람이 엑셀로 옮기고 있다면, "
            + "그 사람이 하는 일이 곧 연동 작업입니다.",
        price: { range: "800만 ~ 3,000만원", period: "1 ~ 4개월" },
        priceNote:
            "한쪽이 API 를 열어두면 아래쪽입니다. 열려 있지 않거나 양쪽 데이터 "
            + "모양이 많이 다르면 올라갑니다.",
        sections: [
            {
                h: "제일 오래 걸리는 건 값을 맞추는 일입니다",
                body: [
                    "A 시스템의 거래처 코드와 B 시스템의 거래처 코드가 다릅니다. 품목 단위도 "
                    + "다르고, 날짜 형식도 다릅니다. 연결 자체보다 이 대응표를 만드는 데 시간이 더 듭니다.",
                    "한 번 맞춰두면 그 뒤로는 손이 안 갑니다. 다만 새 거래처나 새 품목이 생길 때 "
                    + "누가 대응표를 고칠지는 정해둬야 해서, 그 화면을 같이 만듭니다.",
                ],
            },
            {
                h: "틀어졌을 때를 설계해야 합니다",
                body: [
                    "연동은 조용히 틀어지는 게 무섭습니다. 어제까지 잘 넘어가던 게 오늘 안 넘어가는데 "
                    + "아무도 모르면, 한 달 뒤 정산에서 터집니다.",
                    "그래서 넘긴 건수와 받은 건수를 맞춰보고, 안 맞으면 알리도록 만듭니다. "
                    + "같은 건이 두 번 들어가지 않게 막는 것도 기본으로 넣습니다.",
                ],
            },
        ],
        deliverables: [
            "양쪽 항목 대응표와 이를 고치는 화면",
            "연동 이력 — 언제 몇 건이 어느 방향으로 갔는지",
            "건수 대사와 불일치 알림",
            "중복 방지 · 실패 재처리",
        ],
        cases: ["shipping-docs-erp-automation", "tax-docs-auto-issue", "commerce-seller-automation", "n-commerce-extension-crawler"],
        faq: [
            {
                q: "쓰는 ERP 가 더존인데 되나요",
                a: "제품마다 열어둔 범위가 달라서 먼저 확인합니다. API 가 열려 있으면 그쪽으로, "
                    + "아니면 내보내기 파일이나 화면 조작으로 붙입니다. 어느 쪽이든 방법은 대개 있습니다.",
            },
            {
                q: "실시간으로 넘어가야 하나요",
                a: "대부분은 아닙니다. 10분이나 1시간 주기로 충분한 경우가 많고, 그편이 단순하고 "
                    + "덜 깨집니다. 실시간이 꼭 필요한 업무인지 먼저 따져봅니다.",
            },
        ],
    },
];

export const SERVICE_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

// 비용 페이지에서 쓰는 시장 시세. 출처를 밝히고 쓴다.
// 우리가 부른 값이 아니라 공개된 실거래 범위라는 점이 중요하다.
export const MARKET_RATES = {
    source: "위시켓 공개 자료 (플랫폼 실거래 기준, 누적 약 9,511억원 규모)",
    sourceUrl: "https://blog.wishket.com/blog/outsourcing-development-cost",
    rows: [
        { type: "홈페이지 (솔루션 활용)", range: "100만 ~ 600만원" },
        { type: "홈페이지 (자체 개발)", range: "600만 ~ 2,000만원" },
        { type: "자사몰", range: "200만 ~ 1,000만원" },
        { type: "모바일 앱 (단일 플랫폼)", range: "1,000만 ~ 5,000만원" },
        { type: "모바일 앱 (네이티브)", range: "5,000만 ~ 1.5억원" },
        { type: "매칭 플랫폼", range: "3,000만 ~ 7,000만원" },
        { type: "키오스크 프로그램", range: "700만 ~ 3,000만원" },
        { type: "LMS", range: "2,000만 ~ 8,000만원" },
        { type: "ERP (자체 개발)", range: "5,000만 ~ 2.5억원 이상" },
    ],
    chatbot: {
        source: "위시켓 챗봇 개발 프로젝트 공개 자료",
        sourceUrl: "https://blog.wishket.com/blog/chatbot-development-guide",
        avg: "평균 2,420만원 (최소 100만원 ~ 최대 1억원)",
        rows: [
            { type: "규칙 기반 (시나리오형)", range: "300만 ~ 1,500만원", period: "2 ~ 4주" },
            { type: "AI 기반", range: "1,500만 ~ 5,000만원", period: "2 ~ 4개월" },
        ],
    },
};
